import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { getCustomizeScroll } from "@/styles/utils/Utils";
import { breakpoints, colors, IconSize } from "@/styles/utils/vars";
import { ButtonBase } from "@/ui/Button/StyledButton";
import { cssIcon, getSizeSVG } from "@/ui/Icon";
import { StyledLinkBase } from "@/ui/Link/StyledLink";
import { cssNavigationItemWithSub } from "@/ui/Navigation/StyledNavigation";
import { PopoverContainer, StyledPopoverDisclosure, StyledPopoverInner } from "@/ui/Popover/StyledPopover";
import { getTypographyBase } from "@/ui/Typography/Typography";
import { StyledListItem } from "../List/StyledList";
export const GRADIENT_LIGHT = `linear-gradient(
        270deg,
        ${colors.white} 0%,
        ${colors.transparentWhite7} 50%,
        transparent 90%
      )`;
export const cssBreadcrumbCurrent = "cssBreadcrumbCurrent_cte5ubb";
export const cssBreadcrumbNavLink = "cssBreadcrumbNavLink_cd0gpjw";
export const cssBreadcrumbsScrollNotStarted = "cssBreadcrumbsScrollNotStarted_c1ufv246";
export const cssBreadcrumbsScrollEnded = "cssBreadcrumbsScrollEnded_c1348hk2";
export const BreadcrumbsSeparator = /*#__PURE__*/styled('div')({
  name: "BreadcrumbsSeparator",
  class: "BreadcrumbsSeparator_b1m44co9"
});
export const StyledBreadcrumbItem = /*#__PURE__*/styled('div')({
  name: "StyledBreadcrumbItem",
  class: "StyledBreadcrumbItem_swfxddv"
});
export const StyledBreadcrumbs = /*#__PURE__*/styled('div')({
  name: "StyledBreadcrumbs",
  class: "StyledBreadcrumbs_sziu1am"
});
export const StyledBreadcrumbsInner = /*#__PURE__*/styled('div')({
  name: "StyledBreadcrumbsInner",
  class: "StyledBreadcrumbsInner_s1mgfqr5"
});

require("./StyledBreadcrumbs.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledBreadcrumbs.tsx");